import React from "react";

import "./overlay.css";

const Overlay = () => (
  <div className='app__Overlay'>
    <div className='app__Overlay-black' />
    <div className='app__Overlay-img app__bg' />
  </div>
);

export default Overlay;
